class BlockSwatches extends HTMLElement {
  constructor() {
    super();

    this.visibleSwatches = parseInt(this.dataset.optionLimit);

    this.state = {
      totalSwatches: 0,
      remaining: 0,
    };
  }

  connectedCallback() {
    this.totalSwatches = this.querySelectorAll("block-swatch").length;

    this.addEventListener("swatch-does-not-exist", (e) => {
      e.stopPropagation();

      // Just worry about this <block-swatches> element.
      if (e.detail.parentId != this.dataset.id) return;

      this.removeSwatch(e.detail.handle);

      /**
       * This event fires right before actually removing the swatch, so we need
       * to get the current total swatch count and subtract 1.
       */
      this.state.totalSwatches = this.getSwatchCount(this);

      this.updateLabel(this.state.totalSwatches - this.visibleSwatches);
    });
  }

  getSwatchCount(el) {
    return el.querySelectorAll("block-swatch").length;
  }

  removeSwatch(handle) {
    const swatch = this.querySelector(`block-swatch[data-handle='${handle}']`);
    swatch?.remove();
  }

  updateLabel(remaining) {
    const moreLabel = this.querySelector("more-label");

    if (moreLabel) {
      moreLabel.changeCopy(remaining);
    }
  }
}

customElements.define("block-swatches", BlockSwatches);

class MoreLabel extends HTMLElement {
  constructor() {
    super();
  }

  changeCopy(newRemaining) {
    if (newRemaining <= 0) {
      this.remove();
    } else {
      this.innerText = this.dataset.copy.replace("{{ count }}", newRemaining);
    }
  }
}

customElements.define("more-label", MoreLabel);

class BlockSwatch extends HTMLElement {
  constructor() {
    super();
    this.productData = {};
    this.hasLiquidProductData = false;
  }

  async connectedCallback() {
    this.link = this.querySelector("a");
    this.hasLiquidProductData = this.dataset.hasLiquidProdData === "true";

    /**
     * Using Liquid's all_products, some of these swatches will already have
     * their data. But, because of the quantity limit on all_products, some of
     * the swatches need to be populated with JS.
     */

    // So first we check if a swatch is populated. If so, bail.
    if (this.hasLiquidProductData) return;

    // If the swatch is not populated, we can start gathering it's product data\
    this.productData = await this.getProductData(this.dataset.handle);

    // If there isn't a product (404, etc.) bail.
    if (this.productData) {
      this.renderSwatch(this.productData);
    } else {
      /**
       * Emit event so that the "more label" can handle the change too.
       * Event must be emitted before the element is removed!
       */
      this.notifyWrapper(this.dataset.handle, this.dataset.parentId);
    }
  }

  async getProductData(handle) {
    const res = await fetch(`${window.Shopify.routes.root}products/${handle}.js`);

    try {
      const productData = await res.json();
      return productData;
    } catch (error) {
      /**
       * If there was an error fetching the product data, this means that the
       * product that corresponds to this swatch is no longer active on the
       * site. This happens when older tags still exist on the "parent" product.
       */
      return false;
    }
  }

  getRelatedColor(title) {
    // IN: "Arcadian Houndstooth Flannel - Insignia Blue Navy (Final Sale)"
    // OUT: "Insignia Blue Navy (Final Sale)"
    return title.split("-")[1]?.trim();
  }

  getRelatedColorWithoutDisclaimer(title) {
    // IN: "Arcadian Houndstooth Flannel - Insignia Blue Navy (Final Sale)"
    // OUT: "insignia blue navy"
    return title.split("-")[1]?.split("(")[0].trim().replaceAll('"', "").toLowerCase();
  }

  renderSwatch(product) {
    const classes = `product-block-options__item ${
      this.dataset.disableUnavailable === "true" && !product.available
        ? "product-block-options__item--unavailable"
        : ""
    } ${this.dataset.isSwatch === "true" ? "lazyload" : ""}${
      this.dataset.isSwatch === "true" && this.dataset.manualImageLoad === "true" ? "--manual" : ""
    }`;

    this.innerHTML = `
      <a
        href="${product.url}"
        class="${classes}"

        ${
          this.dataset.isSwatch === "true" &&
          this.dataset.swatchMethod === "standard" &&
          `data-swatch="${this.getRelatedColorWithoutDisclaimer(product.title)}"`
        }
      >
        <span class="product-block-options__item__text">${this.getRelatedColor(
          product.title
        )}</span>
      </a>
    `;
  }

  notifyWrapper(swatchHandle, parentId) {
    const swatchRemoved = new CustomEvent("swatch-does-not-exist", {
      bubbles: true,
      cancelable: true,
      detail: {
        handle: swatchHandle,
        parentId,
      },
    });

    this.dispatchEvent(swatchRemoved);
  }
}

customElements.define("block-swatch", BlockSwatch);
